import type { FC } from 'react';

export const GorgiasLogo: FC<{ className?: string }> = ({ className }) => (
  <div className={className ?? 'w-8 h-8 flex items-center justify-center'}>
    <img
      src="/gorgias-logo.png"
      alt="Gorgias"
      className="w-full h-full object-contain"
    />
  </div>
);
